import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import React, { useEffect } from 'react';
import { useField, useForm } from 'react-final-form';
import { EditNewFieldWizardPage } from '../AddFieldModal/EditNewFieldWizardPage';

type EditNewFieldInNewSectionWizardPageProps = {
  groupPrefix: string;
  fieldPrefix: string;
};

export function EditNewFieldInNewSectionWizardPage({
  groupPrefix,
  fieldPrefix,
}: EditNewFieldInNewSectionWizardPageProps) {
  const { change } = useForm();
  const {
    input: { value: isInDuplicableSection },
  } = useField<boolean>(getFieldNameWithPrefix('isDuplicable', groupPrefix));

  /** when going back and switching it to a non-duplicable section, clear out potentially `true` values for `isDuplicableDisplayField` */
  useEffect(() => {
    change(
      getFieldNameWithPrefix('isDuplicableDisplayField', fieldPrefix),
      false,
    );
  }, [change, fieldPrefix, isInDuplicableSection]);

  return (
    <EditNewFieldWizardPage
      prefix={fieldPrefix}
      isInDuplicableSection={isInDuplicableSection}
    />
  );
}
